import React, { useState, useEffect } from 'react';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTSwitch from 'general/components/OtherKeenComponents/KTFormControls/KTSwitch';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import bannerApi from 'api/bannerApi';
import ToastHelper from 'general/helpers/ToastHelper';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import UIHelper from 'general/helpers/UIHelper';
import AppColors from 'general/constants/AppColors';
import KTPagination, { KTPaginationColor } from 'general/components/OtherKeenComponents/KTPagination';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DialogAddBannerView from '../../components/DialogAddBannerView';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import AppResource from 'general/constants/AppResource';

import banner1 from 'assets/icons/1783148333953_194284037513614117_4642898201278877177_0807db0806d4340ac4b91ae8f85890dd.jpg';
import banner2 from 'assets/icons/1783148333933_194284037513614117_4642898201278877177_f1f620bd0bbdcd527d40b8c60a1160af.jpg';
import banner3 from 'assets/icons/1783148333967_194284037513614117_4642898201278877177_e888358da2926ee81df9b264aae828e9.jpg';

BannerListScreen.propTypes = {};

function BannerListScreen(props) {
  const [bannerList, setBannerList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [filter, setFilter] = useState({ page: 0, limit: 20, q: '', status: '', categoryId: '' });
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [toggleVersion, setToggleVersion] = useState(0);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const res = await bannerApi.getBanners(filter);
      if (res && res.data) {
        setBannerList(res.data.data || []);
        setTotalItems(res.data.total || 0);
      }
    } catch (error) {
      ToastHelper.showError('Không thể lấy danh sách banner');
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await bannerApi.getBannerCategories({ limit: 1000 });
      if (res && res.data) {
        setCategoryList(res.data.data || []);
      }
    } catch (error) {
      // do nothing
    }
  };

  useEffect(() => {
    fetchBanners();
  }, [filter]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleChangeStatus = async (row, checked) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        title="Đổi trạng thái"
        contentEl={<>Bạn có chắc chắn muốn thay đổi trạng thái banner "{row.name}" không?</>}
        cancelButtonText="Bỏ qua"
        confirmButtonText="Đồng ý"
        onCancel={() => {
          AppCustomDialogHelper.hide();
          setToggleVersion(v => v + 1);
        }}
        onConfirm={async () => {
          AppCustomDialogHelper.hide();
          try {
            await bannerApi.updateBanner(row.id, { status: checked ? 'ACTIVE' : 'INACTIVE' });
            ToastHelper.showSuccess('Cập nhật trạng thái thành công');
            fetchBanners();
          } catch (error) {
            ToastHelper.showError('Cập nhật trạng thái thất bại');
          }
        }}
        iconEl={<img src={AppResource.images.dialogIcons.dialogWarning} />}
      />,
      'md', true, true
    );
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const newList = [...bannerList];
    const tempOrder = newList[index].displayOrder;
    newList[index].displayOrder = newList[index - 1].displayOrder;
    newList[index - 1].displayOrder = tempOrder;
    const temp = newList[index];
    newList[index] = newList[index - 1];
    newList[index - 1] = temp;
    setBannerList(newList);
  };

  const handleMoveDown = (index) => {
    if (index === bannerList.length - 1) return;
    const newList = [...bannerList];
    const tempOrder = newList[index].displayOrder;
    newList[index].displayOrder = newList[index + 1].displayOrder;
    newList[index + 1].displayOrder = tempOrder;
    const temp = newList[index];
    newList[index] = newList[index + 1];
    newList[index + 1] = temp;
    setBannerList(newList);
  };

  const handleSaveOrder = async () => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        title="Lưu thứ tự"
        contentEl={<>Bạn có chắc chắn muốn lưu thay đổi thứ tự các banner không?</>}
        cancelButtonText="Bỏ qua"
        confirmButtonText="Đồng ý"
        onCancel={() => AppCustomDialogHelper.hide()}
        onConfirm={async () => {
          AppCustomDialogHelper.hide();
          try {
            setLoading(true);
            const updates = bannerList.map(b => ({ id: b.id, displayOrder: b.displayOrder }));
            await bannerApi.bulkUpdateBannerOrder(updates);
            ToastHelper.showSuccess('Lưu thứ tự thành công');
            fetchBanners();
          } catch (error) {
            ToastHelper.showError('Lưu thứ tự thất bại');
            setLoading(false);
          }
        }}
        iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
      />,
      'md', true, true
    );
  };

  const buildMoreActions = (row, index) => {
    return [
      {
        text: 'Lên trên',
        iconElement: <i className="fa-solid fa-arrow-up" style={{ fontSize: '1.1rem' }} />,
        click: () => handleMoveUp(index),
      },
      {
        text: 'Xuống dưới',
        iconElement: <i className="fa-solid fa-arrow-down" style={{ fontSize: '1.1rem' }} />,
        click: () => handleMoveDown(index),
      },
      {
        text: 'Chỉnh sửa',
        iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          AppCustomDialogHelper.show(
            'Chỉnh sửa banner',
            <DialogAddBannerView
              banner={row}
              onCancel={() => AppCustomDialogHelper.hide()}
              onDone={() => {
                AppCustomDialogHelper.hide();
                fetchBanners();
              }}
            />,
            'md',
            false,
            true,
            false,
            false
          );
        },
      },
      {
        text: 'Xóa',
        iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
              title="Xóa banner"
              contentEl={<>Xóa banner "{row.name}"? Bạn có chắc chắn muốn xóa không?</>}
              cancelButtonText="Bỏ qua"
              confirmButtonText="Xóa"
              confirmButtonRed={true}
              onCancel={() => AppCustomDialogHelper.hide()}
              onConfirm={() => {
                AppCustomDialogHelper.hide();
                bannerApi.deleteBanner(row.id).then(() => {
                  ToastHelper.showSuccess('Xóa banner thành công');
                  fetchBanners();
                }).catch(() => {
                  ToastHelper.showError('Xóa banner thất bại');
                });
              }}
              iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            />,
            'md', true, true
          );
        },
      },
    ];
  };
  const handleAddNew = () => {
    AppCustomDialogHelper.show(
      'Thêm mới banner',
      <DialogAddBannerView
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          fetchBanners();
        }}
      />,
      'md',
      false,
      true,
      false, // canClickOutsideToDismiss
      false  // keyboard
    );
  };

  const columns = [
    {
      id: 'IMAGE',
      name: UIHelper.buildTableColumn('Ảnh'),
      selector: (row) => (
        <img src={row.image} alt={row.name} style={{ width: '100px', height: 'auto', borderRadius: '4px' }} />
      ),
      width: '150px',
      style: tableStyle.columns.normal,
    },
    {
      id: 'NAME',
      name: UIHelper.buildTableColumn('Tên banner'),
      selector: (row) => row.name,
      minWidth: '150px',
      style: tableStyle.columns.normal,
    },
    {
      id: 'POSITION',
      name: UIHelper.buildTableColumn('Vị trí'),
      selector: (row) => row.position || '-',
      minWidth: '150px',
      style: tableStyle.columns.normal,
    },
    {
      id: 'LINK',
      name: UIHelper.buildTableColumn('Đường dẫn'),
      selector: (row) => row.link || '-',
      minWidth: '150px',
      style: tableStyle.columns.normal,
    },
    {
      id: 'CATEGORY',
      name: UIHelper.buildTableColumn('Tên danh mục'),
      selector: (row) => row.category?.name || '-',
      minWidth: '200px',
      style: tableStyle.columns.normal,
    },
    {
      id: 'STATUS',
      name: UIHelper.buildTableColumn('Trạng thái'),
      selector: (row) => (
        <KTSwitch
          key={`status_${row.id}_${toggleVersion}`}
          name={`status_${row.id}`}
          checked={row.status === 'ACTIVE'}
          additionalClassName="switch-ios"
          onChange={(checked) => {
            handleChangeStatus(row, checked);
          }}
        />
      ),
      width: '120px',
      style: tableStyle.columns.center,
    },
    {
      name: UIHelper.buildTableColumn('Thao tác'),
      minWidth: '160px',
      maxWidth: '180px',
      style: {
        position: 'sticky',
        right: 0,
        backgroundColor: '#fff',
        borderLeft: '1px solid #ebedfe',
      },
      cell: (row, index) => {
        return UIHelper.buildMoreActionsButton(buildMoreActions(row, index), true, false, 4);
      },
    },
  ];

  return (
    <div className="container-fluid px-4 my-4">
      {UIHelper.buildCard(
        <div>
          <div className="pb-4">
            {/* header */}
            <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
              {/* title */}
              <div className="d-flex flex-column">
                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                  Danh sách Banner
                </span>
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  Tổng:{' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                    {totalItems} banner
                  </span>
                </span>
              </div>

              {/* actions */}
              <div className="d-flex gap-2">
                {UIHelper.buildGreenButton(
                  'Lưu thứ tự',
                  handleSaveOrder,
                  <i className="fa-regular fa-floppy-disk" />
                )}
                {UIHelper.buildBlueButton(
                  'Thêm mới banner',
                  handleAddNew,
                  <i className="fa-regular fa-circle-plus" />
                )}
              </div>
            </div>

            {/* filter */}
            <div className="row m-0 p-0 px-2">
              <div className="col-3 mb-4 px-2">
                {UIHelper.buildFormLabel('Tìm kiếm')}
                <KTFormSearch
                  name="search"
                  placeholder="Theo tên banner"
                  value={filter.q || ''}
                  onSubmit={(text) => {
                    setFilter({ ...filter, q: text, page: 0 });
                  }}
                />
              </div>
              <div className="col-3 mb-4 px-2">
                {UIHelper.buildFormLabel('Trạng thái hiển thị')}
                <select
                  className="form-control"
                  style={{
                    backgroundColor: '#fff',
                    border: '1px solid #E4E6EF',
                    color: AppColors.gray[700],
                    height: '38px',
                    borderRadius: '4px',
                  }}
                  value={filter.status}
                  onChange={(e) => setFilter({ ...filter, status: e.target.value, page: 0 })}
                >
                  <option value="">Tất cả</option>
                  <option value="ACTIVE">Đang hiển thị</option>
                  <option value="INACTIVE">Đang ẩn</option>
                </select>
              </div>
              <div className="col-3 mb-4 px-2">
                {UIHelper.buildFormLabel('Danh mục banner')}
                <select
                  className="form-control"
                  style={{
                    backgroundColor: '#fff',
                    border: '1px solid #E4E6EF',
                    color: AppColors.gray[700],
                    height: '38px',
                    borderRadius: '4px',
                  }}
                  value={filter.categoryId}
                  onChange={(e) => setFilter({ ...filter, categoryId: e.target.value, page: 0 })}
                >
                  <option value="">Tất cả</option>
                  {categoryList.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* table */}
            <div>
              <div className="px-4">
                <KTTable
                  columns={columns}
                  items={bannerList}
                  selectableRows={false}
                  striped={false}
                  compactGrid={false}
                  progressPending={loading}
                  noDataComponent={UIHelper.buildEmptyNoData(
                    'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                  )}
                />
              </div>
            </div>

            {/* pagination */}
            <div className="px-4 mt-2">
              <KTPagination
                currentPage={filter?.page + 1}
                rowCount={totalItems}
                rowsPerPage={filter?.limit}
                currentItemInPageCount={bannerList?.length}
                onChangePage={(newPage) => {
                  setFilter({ ...filter, page: parseInt(newPage) - 1 });
                }}
                onChangeRowsPerPage={(newRowsPerPage) => {
                  setFilter({ ...filter, limit: parseInt(newRowsPerPage), page: 0 });
                }}
                loading={false}
                color={KTPaginationColor.success}
                appendText="banner"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BannerListScreen;
